/* =========================================================
   BEATO PROGRAM FAQ — NEW JS (isolated, all selectors use -new suffix)
   Original source: beato-glp-program-faq.js (GLP-New-Theme)
   ========================================================= */
(function () {
  function closeItemNew(item) {
    var trigger = item.querySelector('[data-beato-program-faq-new-trigger]');
    var panel = item.querySelector('[data-beato-program-faq-new-panel]');

    if (!trigger || !panel) return;

    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }

  function openItemNew(item) {
    var trigger = item.querySelector('[data-beato-program-faq-new-trigger]');
    var panel = item.querySelector('[data-beato-program-faq-new-panel]');

    if (!trigger || !panel) return;

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }

  function initBeatoProgramFaqNew(root) {
    var scope = root || document;
    var accordions = scope.querySelectorAll('[data-beato-program-faq-new-accordion]');

    accordions.forEach(function (accordion) {
      if (accordion.dataset.initializedNew === 'true') return;
      accordion.dataset.initializedNew = 'true';

      accordion.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-beato-program-faq-new-trigger]');
        if (!trigger || !accordion.contains(trigger)) return;

        var item = trigger.closest('[data-beato-program-faq-new-item]');
        if (!item) return;

        var isOpen = item.classList.contains('is-open');
        var items = accordion.querySelectorAll('[data-beato-program-faq-new-item]');

        items.forEach(function (otherItem) {
          closeItemNew(otherItem);
        });

        if (!isOpen) {
          openItemNew(item);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBeatoProgramFaqNew(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initBeatoProgramFaqNew(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initBeatoProgramFaqNew(event.target);
  });
})();
